import { useDispatch, useSelector } from 'react-redux';

import {
  clearSelection,
  resetMusicCoverOverrides,
  setCurrentMusicContext,
  setIsRegeneratingImage,
  setIsRegeneratingLyrics,
  setIsRegeneratingMusic,
  setMusicCoverOverride,
  setRegeneratedImageUrl,
  setRegeneratedTaskId,
  setSelectedImageId,
  setSelectedImageUrl,
  setSelectedSongId,
} from '@store/reducers/generationReducer.ts';
import { RootState } from '../../store/store';

export const useGenerationState = () => {
  const selectedImageUrl = useSelector(
    (state: RootState) => state.generationReducer.selectedImageUrl,
  );
  const selectedImageId = useSelector(
    (state: RootState) => state.generationReducer.selectedImageId,
  );
  const regeneratedImageUrl = useSelector(
    (state: RootState) => state.generationReducer.regeneratedImageUrl,
  );
  const selectedSongId = useSelector(
    (state: RootState) => state.generationReducer.selectedSongId,
  );
  const currentMusicTaskId = useSelector(
    (state: RootState) => state.generationReducer.currentMusicTaskId,
  );
  const currentMusicPrompt = useSelector(
    (state: RootState) => state.generationReducer.currentMusicPrompt,
  );
  const currentMusicStyle = useSelector(
    (state: RootState) => state.generationReducer.currentMusicStyle,
  );
  const currentMusicThumbnailUrl = useSelector(
    (state: RootState) => state.generationReducer.currentMusicThumbnailUrl,
  );
  const regeneratedTaskId = useSelector(
    (state: RootState) => state.generationReducer.regeneratedTaskId,
  );
  const isRegeneratingImage = useSelector(
    (state: RootState) => state.generationReducer.isRegeneratingImage,
  );
  const isRegeneratingMusic = useSelector(
    (state: RootState) => state.generationReducer.isRegeneratingMusic,
  );
  const isRegeneratingLyrics = useSelector(
    (state: RootState) => state.generationReducer.isRegeneratingLyrics,
  );
  const musicCoverOverrides = useSelector(
    (state: RootState) => state.generationReducer.musicCoverOverrides,
  );

  const dispatch = useDispatch();

  const handleClearSelection = () => {
    dispatch(clearSelection(undefined));
  };

  return {
    selectedImageUrl,
    selectedImageId,
    regeneratedImageUrl,
    selectedSongId,
    currentMusicTaskId,
    currentMusicPrompt,
    currentMusicStyle,
    currentMusicThumbnailUrl,
    regeneratedTaskId,
    isRegeneratingImage,
    isRegeneratingMusic,
    isRegeneratingLyrics,
    musicCoverOverrides,
    setSelectedImageUrl: (url: string | null) =>
      dispatch(setSelectedImageUrl(url)),
    setSelectedImageId: (id: 1 | 2 | null) => dispatch(setSelectedImageId(id)),
    setRegeneratedImageUrl: (url: string | null) =>
      dispatch(setRegeneratedImageUrl(url)),
    setSelectedSongId: (id: 1 | 2 | null) => dispatch(setSelectedSongId(id)),
    setCurrentMusicContext: (context: {
      taskId: string;
      prompt: string;
      musicStyle?: string;
      thumbnailUrl?: string;
    }) => dispatch(setCurrentMusicContext(context)),
    setRegeneratedTaskId: (taskId: string | null) =>
      dispatch(setRegeneratedTaskId(taskId)),
    setIsRegeneratingImage: (isRegenerating: boolean) =>
      dispatch(setIsRegeneratingImage(isRegenerating)),
    setIsRegeneratingMusic: (isRegenerating: boolean) =>
      dispatch(setIsRegeneratingMusic(isRegenerating)),
    clearImageSelection: handleClearSelection,
    setIsRegeneratingLyrics: (isRegenerating: boolean) =>
      dispatch(setIsRegeneratingLyrics(isRegenerating)),
    setMusicCoverOverride: (songId: 1 | 2, imageUrl: string | null) =>
      dispatch(setMusicCoverOverride({ songId, imageUrl })),
    resetMusicCoverOverrides: () => dispatch(resetMusicCoverOverrides()),
  };
};
